import type { SiteId } from '@hotjar/site';

export type Channel = string;

export type Url = string;

export type Timestamp = number;

export interface GenericSuccessData {
  success: true;
}

export type { SiteId };

const API_ROOT = `/api/v1/sites`;

export function createSiteEndpointPath(siteId: SiteId): Url {
  return `${API_ROOT}/${siteId}/slack`;
}
